import React from 'react';
import {ReactComponent as Arrow} from '../../assets/arrow.svg';
import styles from './Link.module.scss';
import { mergeClassNames } from '../../utils/mergeClassNames';
import ObjectUtils from '../../utils/ObjectUtils';

interface FileLinkProps {
	decoration?: boolean;
	arrow?: boolean;
}

export class FileLink extends React.Component<FileLinkProps & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>>
{
	static defaultProps = {
		decoration: false,
		arrow: true,
	};

	render()
	{
		const props: any = ObjectUtils.filter(this.props, ['arrow', 'decoration'], true);
		return (
			<a {...props} className={mergeClassNames([props['className'], 'link', !this.props.decoration ? 'no-decoration' : null], styles)}>
				{this.props['children']}
				{this.props.arrow && <Arrow className={mergeClassNames(['arrow'], styles)} />}
			</a>
		);
	}
}
